import Vue from 'vue';
import ClientChat from 'Root/classes/ClientChat.class';

export default {
  methods: {
    _initClientChat() {
      if (!Vue.prototype.$chat) {
        Vue.prototype.$chat = new ClientChat(this.$socket, this.$store.state.user);
      }
    },
  },
};
